















































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import { Widget } from '../base/'

import StatusDetailTable from './StatusDetailTable.vue'
import NoWidgetAccess from '../../components/NoWidgetAccess.vue'
import { predefinedColumns } from './StatusDetail.widget'

export default Vue.extend({
  components: {
    StatusDetailTable,
    NoWidgetAccess
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    },
    isEditable: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([ 'getMonitorStatusData']),
    accessRightsAlarmFields(): any {
      return this.$store.state.user.access.alarm_fields
    },
    denyAccessRights(): boolean {
      return Object.values(this.$store.state.user.access.alarm_fields).includes(0)
    },
    wbuuid(): string | undefined {
      return this.widget.wbUUID
    },
    showGroupName(): boolean {
      return this.widget?.customSettings?.settings.showGroupName.checked
    },
    showStatusNames(): boolean {
      return this.widget?.customSettings?.settings.showStatusNames.checked
    },
    showFullTime(): boolean {
      return this.widget?.customSettings?.settings.showFullTime.checked
    },
    fontBoldTable(): boolean {
      return this.widget?.customSettings?.settings.fontBoldTable.checked
    },
    paddingVerticalRows(): number {
      return parseInt(this.widget?.customSettings?.settings.paddingVerticalRows.value)
    },
    widthColumns(): object {
      return {
        'name': parseInt(this.widget?.customSettings?.settings.widthColumnsName.value),
        'updated': parseInt(this.widget?.customSettings?.settings.widthColumnsUpdated.value),
        'vehicles': parseInt(this.widget?.customSettings?.settings.widthColumnsVehicles.value),
        'notes': parseInt(this.widget?.customSettings?.settings.widthColumnsNotes.value),
        'qualifications': parseInt(this.widget?.customSettings?.settings.widthColumnsQualifications.value)
      }
    },
    dynamicWidthColumns(): object {
      return {
        'name': this.widget?.customSettings?.settings.dynamicWidthColumnsName.checked,
        'updated': this.widget?.customSettings?.settings.dynamicWidthColumnsUpdated.checked,
        'vehicles': this.widget?.customSettings?.settings.dynamicWidthColumnsVehicles.checked,
        'notes': this.widget?.customSettings?.settings.dynamicWidthColumnsNotes.checked,
        'qualifications': this.widget?.customSettings?.settings.dynamicWidthColumnsQualifications.checked
      }
    },
    sortingUnits(): number {
      return parseInt(this.widget?.customSettings?.settings.sortUnits.value)
    },
    sortingListStatus(): Array<any> {
      return this.widget?.customSettings?.settings.sortStatus.data.sortedStatus || []
    },
    sortingStatusColumns(): Array<any> {
      return this.widget?.customSettings?.settings.sortStatusColumns.data.sortedStatusColumns || []
    },
    selectedGroup(): string | number {
      return this.widget?.customSettings?.settings.selectedGroup.data.selectedGroup || 'all'
    },
    groupName(): string {
      if (this.selectedGroup === 'all') return 'Alle Gruppen'
      if (this.selectedGroup === 'none') return 'Keine Gruppe'

      return this.$store.state.cluster.group[this.selectedGroup].name
    },
    sortingListQualifications(): Array<any> {
      return this.sortingStatusColumns.filter(
        (elem: string) => !predefinedColumns.includes(elem)
      ) || []
    },
    statusData(): Array<any> {
      return this.getMonitorStatusData(this.sortingListStatus, this.sortingListQualifications, true, this.sortingUnits, this.selectedGroup)
    },
    isOnlyStatus(): boolean {
      return this.statusData.length === 1
    },
    fontSizes(): object {
      return {
        'statusNames': this.widget?.customSettings?.settings.fontSizeStatusNames.value,
        'table': this.widget?.customSettings?.settings.fontSizeTable.value
      }
    },
    rowStyles(): object {
      return {
        'padding-top': this.paddingVerticalRows ? `${this.paddingVerticalRows}px` : false,
        'padding-bottom':this.paddingVerticalRows ?  `${this.paddingVerticalRows}px` : false,
        'font-weight': 'bold',
        'font-size': this.fontSizes.statusNames ? `${this.fontSizes.statusNames}px`: false
      }
    }
  }
})
